<goab-modal
  [open]="open()"
  [heading]="heading()"
  [closable]="true"
  [attr.data-testid]="testIdPrefix() + '-modal'"
  (onClose)="cancelled.emit()"
>
  <goab-text
    tag="p"
    mt="none"
    mb="none"
    [attr.data-testid]="testIdPrefix() + '-message'"
  >
    {{ message() }}
  </goab-text>

  <div slot="actions" class="confirm-modal-actions">
    <goab-button
      type="secondary"
      [attr.data-testid]="testIdPrefix() + '-cancel-button'"
      (click)="cancelled.emit()"
    >
      {{ cancelLabel() }}
    </goab-button>
    <goab-button
      type="primary"
      [attr.data-testid]="testIdPrefix() + '-confirm-button'"
      (click)="confirmed.emit()"
    >
      {{ confirmLabel() }}
    </goab-button>
  </div>
</goab-modal>
